import type { ILabAccountLabManagementColors } from '@team-milva/lab-models/labAccount'

export const THEME_COLORS_VARS = {
  // CTA
  ctaBackgroundColor: '--cta-bg',
  ctaTextColor: '--cta-text',

  // Header
  headerBackgroundColor: '--header-bg',
  headerBorderColor: '--header-border',
  headerUserCircleColor: '--header-user-circle',
  headerIconColor: '--header-icon',
  headerIconHoverColor: '--header-icon-hover',
  headerIconHoverBackgroundColor: '--header-icon-hover-bg',

  // Menu
  menuBackgroundColor: '--menu-bg',
  menuBorderColor: '--menu-border',
  activeMenuItemBackgroundColor: '--menu-active-item-bg',
  activeMenuItemTextColor: '--menu-active-item-text',
  menuItemHoverBackgroundColor: '--menu-item-hover-bg',
} as const

export const DEFAULT_THEME_COLORS_VARS = {
  // CTA
  ctaBackgroundColor: '--cta-bg-default',
  ctaTextColor: '--cta-text-default',

  // Header
  headerBackgroundColor: '--header-bg-default',
  headerBorderColor: '--header-border-default',
  headerUserCircleColor: '--header-user-circle-default',
  headerIconColor: '--header-icon-default',
  headerIconHoverColor: '--header-icon-hover-default',
  headerIconHoverBackgroundColor: '--header-icon-hover-bg-default',

  // Menu
  menuBackgroundColor: '--menu-bg-default',
  menuBorderColor: '--menu-border-default',
  activeMenuItemBackgroundColor: '--menu-active-item-bg-default',
  activeMenuItemTextColor: '--menu-active-item-text-default',
  menuItemHoverBackgroundColor: '--menu-item-hover-bg-default',
} as const

function setProperty(root: HTMLElement, prop: string, value: string): void {
  if (root.style.getPropertyValue(prop).trim() !== value) {
    root.style.setProperty(prop, value)
  }
}

export function updateThemeColors({
  themeColors: {
    ctaBackgroundColor,
    ctaTextColor,
    activeMenuItemBackgroundColor,
    activeMenuItemTextColor,
  },
}: {
  themeColors: ILabAccountLabManagementColors
}): void {
  const root = document.documentElement
  setProperty(
    root,
    THEME_COLORS_VARS.ctaBackgroundColor,
    ctaBackgroundColor || `var(${DEFAULT_THEME_COLORS_VARS.ctaBackgroundColor})`
  )
  setProperty(
    root,
    THEME_COLORS_VARS.ctaTextColor,
    ctaTextColor || `var(${DEFAULT_THEME_COLORS_VARS.ctaTextColor})`
  )
  setProperty(
    root,
    THEME_COLORS_VARS.activeMenuItemBackgroundColor,
    activeMenuItemBackgroundColor ||
      `var(${DEFAULT_THEME_COLORS_VARS.activeMenuItemBackgroundColor})`
  )
  setProperty(
    root,
    THEME_COLORS_VARS.activeMenuItemTextColor,
    activeMenuItemTextColor ||
      `var(${DEFAULT_THEME_COLORS_VARS.activeMenuItemTextColor})`
  )
}
